import * as React from 'react';
import { AppContext, IAppContext, IFormStateBase } from '../Types/Intyg.types';
import Heading from '../FormSections/Heading';
import ValjYrke from '../FormSections/ValjYrke';
import FormDivider from '../FormSections/FormDivider';
import SprakForIntyget from '../FormSections/SprakForIntyget';
import TaEmotIntyget from '../FormSections/TaEmotIntyget';
import Personuppgifter from '../FormSections/Personuppgifter';
import Adressuppgifter from '../FormSections/Adressuppgifter';
import SubmitButton from '../FormSections/SubmitButton';
import Inforuta from '../FormSections/Inforuta';
import { ApplicationType, Section } from '../Types/Intyg.enums';
import FileUploaderClientOnly from '../FormSections/FileUploaderClientOnly';
import FileUploader from '../FormSections/FileUploader';
import DeleteAnsokan from '../FormSections/DeleteAnsokan';
import Villkor from '../FormSections/Villkor';
import { FormBase } from '../Types/FormBase';

export interface IArtikel3_3Props {}

export interface IArtikel3_3State extends IFormStateBase {}

export class Artikel3_3 extends FormBase<IArtikel3_3Props, IArtikel3_3State> {
  private fileRef: React.RefObject<FileUploader>;
  private fileClientOnlyRef: React.RefObject<FileUploaderClientOnly>;

  static contextType = AppContext;
  constructor(props: IArtikel3_3Props) {
    super(props);

    this.state = { isFormValid: false };

    this.fileRef = React.createRef();
    this.fileClientOnlyRef = React.createRef();

    this.sectionRefMap.set(Section.Fileupload, this.fileRef);
    this.sectionRefMap.set(Section.FileuploadClient, this.fileClientOnlyRef);
  }

  public render() {
    const appContext = this.context as IAppContext;

    return (
      <>
        <Heading />
        <Inforuta />
        <ValjYrke ref={this.sectionRefMap.get(Section.ValjYrke) as React.RefObject<ValjYrke>} />
        <FormDivider />
        <SprakForIntyget ref={this.sectionRefMap.get(Section.SprakForIntyget) as React.RefObject<SprakForIntyget>} />
        <TaEmotIntyget ref={this.sectionRefMap.get(Section.TaEmotIntyget) as React.RefObject<TaEmotIntyget>} />
        <FormDivider />
        {appContext.applicationType === ApplicationType.Eservice && <FileUploader ref={this.fileRef} />}
        {appContext.applicationType === ApplicationType.Webform && (
          <FileUploaderClientOnly ref={this.fileClientOnlyRef} />
        )}
        <Personuppgifter ref={this.sectionRefMap.get(Section.Personuppgifter) as React.RefObject<Personuppgifter>} />
        <FormDivider />
        {appContext.model.skickaPost && (
          <>
            <Adressuppgifter
              ref={this.sectionRefMap.get(Section.Adressuppgifter) as React.RefObject<Adressuppgifter>}
            />
            <FormDivider />
          </>
        )}
        {<Villkor ref={this.sectionRefMap.get(Section.Villkor) as React.RefObject<Villkor>} />}
        <SubmitButton isEnabled={this.state.isFormValid} />
        <FormDivider />
        {appContext.applicationType === ApplicationType.Eservice && <DeleteAnsokan />}
      </>
    );
  }
}
